import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";

interface ISpecialtyComboBoxProps {
    specialtyOptions: LicenceOrganisationSpecialisation[];
    specialty: LicenceOrganisationSpecialisation;
    onSpecialtySelect: (specialty: LicenceOrganisationSpecialisation) => void;
    isRequired?: boolean;
    isValid: boolean;
}

function SpecialtyComboBox(props: ISpecialtyComboBoxProps): JSX.Element {
    return (
        <div>
            <select
                id="LicenseOrganizationSpecialization"
                onChange={e => props.onSpecialtySelect(props.specialtyOptions.find(p => p.Id === e.target.value) ?? null)}
                className={`${props.isValid ? "" : "invalid "}form-control myle-control`}
                value={props.specialty?.Id ?? ""}
                data-cy="userProfile-practiceSpecialty"
            >
                <option />
                {props.specialtyOptions.map(p => (
                    <option
                        key={p.Id}
                        value={p.Id}
                    >
                        {LicenceOrganisationSpecialisation.getSpecialtyName(p)}
                    </option>
                ))}
            </select>
        </div>
    );
}

export { SpecialtyComboBox };
